import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <section className="flex w-full flex-col items-center justify-center px-4 py-24 text-center md:py-32">
      <p className="font-heading text-6xl font-bold text-background-300 md:text-8xl">404</p>
      <h1 className="mt-6 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
        这个页面暂时不存在
      </h1>
      <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600">
        你访问的地址是「{location.pathname}」，它可能已经调整或从未创建。不妨从下面的入口重新出发。
      </p>
      <div className="mt-8 flex flex-col gap-3 sm:flex-row">
        <Link
          to="/"
          className="inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 px-5 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap cursor-pointer"
        >
          <i className="ri-home-4-line text-base leading-none"></i>
          返回首页
        </Link>
        <Link
          to="/topics"
          className="inline-flex items-center justify-center gap-2 rounded-md border border-background-300 px-5 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600 whitespace-nowrap cursor-pointer"
        >
          浏览选题库
          <i className="ri-arrow-right-line text-base leading-none"></i>
        </Link>
      </div>
    </section>
  );
}